export const svgDefs = {
  role: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <rect x="${w / 4}" y="${h / 4}" width="${w}" height="${h}"  rx="${w / 10}" ry="${h / 10}" fill="none" />
        `,
  }),
  thread: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <rect x="${w / 4}" y="${h / 4}" width="${w}" height="${h}"  rx="${w / 10}" ry="${h / 10}" fill="none" stroke-dasharray="4" />
        `,
  }),
  action: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
      <rect x="${w / 4}" y="${h / 4}" width="${w}" height="${h}" />
      <line x1="${(w * 3) / 4}" y1="0" x2="${(w * 3) / 4}" y2="${w / 4}" />
      <line x1="${(w * 3) / 4}" y1="${(h * 5) / 4}" x2="${(w * 3) / 4}" y2="${(h * 3) / 2}" />
    `,
  }),
  case_refinement: (w = 40, h = 30) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${w * 3} ${(h * 3) / 2}`,
    content: `
            <polygon points="${w / 3},${h / 4} ${(w * 4) / 3},${h / 4} ${(w * 5) / 6},${(h * 11) / 8}" fill="none" />
            <line x1="${(w * 5) / 6}" y1="${(h * 5) / 4}" x2="${(w * 5) / 6}" y2="${(h * 7) / 4}" />
            <line x1="${w / 8}" y1="${(h * 3) / 4}" x2="${w / 2}" y2="${(h * 3) / 4}" />
            <line x1="${(w * 9) / 8}" y1="${(h * 3) / 4}" x2="${(w * 9) / 4}" y2="${(h * 3) / 4}" />
            <polygon points="${w * 2},${h / 4} ${w * 3},${h / 4} ${w * (5 / 2)},${(h * 11) / 8}" fill="none" />
            <line x1="${w * (5 / 2)}" y1="${(h * 5) / 4}" x2="${w * (5 / 2)}" y2="${(h * 7) / 4}" />
            <line x1="${(w * 11) / 4}" y1="${(h * 3) / 4}" x2="${w * (7 / 2)}" y2="${(h * 3) / 4}" />`,
  }),
  connection: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${w} ${h}`,
    content: `
        <line x1="${w / 3}" y1="${h / 2}" x2="${(w * 2) / 3}" y2="${h / 2}" />
        <rect x="1" y="${h / 4}" width="${w / 3}" height="${h / 2}" fill="none" />
        <rect x="${-1 + (w * 2) / 3}" y="${h / 4}" width="${w / 3}" height="${h / 2}" fill="none"/>
        `,
  }),
  connection_remove: (w = 20, h = 20) => {
    const centerX = w / 2;
    const centerY = h / 2;
    const xSize = Math.min(w, h) / 2; // Adjusted to use the smaller of width or height
    return {
      width: `${w}px`,
      height: `${h}px`,
      viewBox: `0 0 ${w} ${h}`,

      content: `
        <line x1="${w / 3}" y1="${h / 2}" x2="${(w * 2) / 3}" y2="${h / 2}" />
        <rect x="1" y="${h / 4}" width="${w / 3}" height="${h / 2}" fill="none" />  
        <rect x="${-1 + (w * 2) / 3}" y="${h / 4}" width="${w / 3}" height="${h / 2}" fill="none"/>
        <line class="warn"
            x1="${centerX - xSize}"
            y1="${centerY - xSize}"
            x2="${centerX + xSize}"
            y2="${centerY + xSize}"
          />        
        <line class="warn"
            x1="${centerX - xSize}"
            y1="${centerY + xSize}"
            x2="${centerX + xSize}"
            y2="${centerY - xSize}"
          />
        `,
    };
  },
  connection_segment_remove: (w = 10, h = 10) => {
    const centerX = (w * 2) / 7;
    const centerY = h / 2;
    const xSize = Math.min(w, h) / 4; // Adjusted to use the smaller of width or height
    return {
      width: `${w}px`,
      height: `${h}px`,
      viewBox: `0 0 ${w} ${h}`,

      content: `
        <line x1="${w / 5}" y1="${h / 2}" x2="${(w * 2) / 5}" y2="${h / 2}" />
        <line x1="${(w * 3) / 5}" y1="${h / 2}" x2="${(w * 4) / 5}" y2="${h / 2}" />
        <rect x="1" y="${h / 4}" width="${w / 5}" height="${h / 2}" fill="none" />  
        <rect x="${-1 + (w * 2) / 5}" y="${h / 4}" width="${w / 5}" height="${h / 2}" fill="none"/>
        <rect x="${-1 + (w * 4) / 5}" y="${h / 4}" width="${w / 5}" height="${h / 2}" fill="none"/>
        <line class="warn"
            x1="${centerX - xSize}"
            y1="${centerY - xSize}"
            x2="${centerX + xSize}"
            y2="${centerY + xSize}"
          />        
        <line class="warn"
            x1="${centerX - xSize}"
            y1="${centerY + xSize}"
            x2="${centerX + xSize}"
            y2="${centerY - xSize}"
          />
        `,
    };
  },
  initiator: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <rect x="${w / 4}" y="${h / 4}" width="${w}" height="${h}" fill="lightgray" />
        <line x1="${(w * 3) / 4}" y1="0" x2="${(w * 3) / 4}" y2="${w / 4}" />
        <line x1="${(w * 3) / 4}" y1="${(h * 5) / 4}" x2="${(w * 3) / 4}" y2="${(h * 3) / 2}" />
        <line x1="${w / 4}" y1="${(h * 3) / 4}" x2="${(w * 3) / 4}" y2="${h / 4}" />        
        <line x1="${(w * 5) / 4}" y1="${h / 4}" x2="${w / 4}" y2="${(h * 5) / 4}" />
        <line x1="${(w * 3) / 4}" y1="${(h * 5) / 4}"" x2="${(w * 5) / 4}" y2="${(h * 3) / 4}" />
        `,
  }),
  interaction: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <rect x="${w / 4}" y="${h / 4}" width="${w}" height="${h}" fill="none" />
        <line x1="${(w * 3) / 4}" y1="0" x2="${(w * 3) / 4}" y2="${w / 4}" />
        <line x1="${(w * 3) / 4}" y1="${(h * 5) / 4}" x2="${(w * 3) / 4}" y2="${(h * 3) / 2}" />
        `,
  }),
  part_refinement: (w = 40, h = 30) => ({
    width: `${w * 2}px`,
    height: `${(h * 3) / 2}px`,
    viewBox: `0 0 ${w * 3} ${(h * 3) / 2}`,
    content: `
            <polygon points="${w / 3},${(h * 11) / 8} ${(w * 4) / 3},${(h * 11) / 8} ${(w * 5) / 6},${h / 4}" fill="none" />
            <line x1="${(w * 5) / 6}" y1="${(h * 11) / 8}" x2="${(w * 5) / 6}" y2="${(h * 7) / 4}" />
            <line x1="${w / 8}" y1="${(h * 3) / 4}" x2="${w / 2}" y2="${(h * 3) / 4}" />
            <line x1="${(w * 9) / 8}" y1="${(h * 3) / 4}" x2="${(w * 9) / 4}" y2="${(h * 3) / 4}" />
            <polygon points="${w * 2},${(h * 11) / 8} ${w * 3},${(h * 11) / 8} ${w * (5 / 2)},${h / 4}" fill="none" />
            <line x1="${w * (5 / 2)}" y1="${(h * 11) / 8}" x2="${w * (5 / 2)}" y2="${(h * 7) / 4}" />
            <line x1="${(w * 11) / 4}" y1="${(h * 3) / 4}" x2="${w * (7 / 2)}" y2="${(h * 3) / 4}" />`,
  }),
  part_repeat: (w = 40, h = 30) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 5) / 2} ${(h * 3) / 2}`,
    content: `
            <polygon points="${w / 3},${(h * 11) / 8} ${(w * 4) / 3},${(h * 11) / 8} ${(w * 5) / 6},${h / 4}" fill="none" />
            <line x1="${(w * 5) / 6}" y1="${(h * 11) / 8}" x2="${(w * 5) / 6}" y2="${(h * 7) / 4}" />
            <line x1="${w / 8}" y1="${(h * 3) / 4}" x2="${w / 2}" y2="${(h * 3) / 4}" />
            <line x1="${(w * 9) / 8}" y1="${(h * 3) / 4}" x2="${(w * 3) / 2}" y2="${(h * 3) / 4}" />
            <text x="${w + w / 8}" y="${(h * 9) / 8}" font-size="46" text-anchor="right">*</text>
        `,
  }),
  spring: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <path d="M10,0 v5 l5,3 l-10,3 l10,3 l-10,3 l5,3 v5" />
       `,
  }),
  start_role: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <rect x="${w / 4}" y="${h / 4}" width="${w}" height="${h}" fill="none" />
        <line x1="${w / 4}" y1="${h / 4}" x2="${(w * 5) / 4}" y2="${(h * 5) / 4}" />
        <line x1="${(w * 5) / 4}" y1="${h / 4}" x2="${w / 4}" y2="${(h * 5) / 4}" />
        <line x1="${(w * 3) / 4}" y1="0" x2="${(w * 3) / 4}" y2="${w / 4}" />
        <line x1="${(w * 3) / 4}" y1="${(h * 5) / 4}" x2="${(w * 3) / 4}" y2="${(h * 3) / 2}" />
        `,
  }),
  state: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <ellipse cx="${(w * 3) / 4}" cy="${(h * 3) / 4}" rx="${w / 2}" ry="${h / 4}" fill="none" />
        <line x1="${(w * 3) / 4}" y1="5" x2="${(w * 3) / 4}" y2="${(h * 3) / 4}" />
        <line x1="${(w * 3) / 4}" y1="${h}" x2="${(w * 3) / 4}" y2="${(h * 5) / 4}" />
        `,
  }),
  trigger: (w = 20, h = 20) => ({
    width: `${w}px`,
    height: `${h}px`,
    viewBox: `0 0 ${(w * 3) / 2} ${(h * 3) / 2}`,
    content: `
        <path d="M5,10 l${w * 0.25},0 l${w * 0.15},${h * 0.15} l${w * 0.35},0 v-${h * 0.15} 
        l${w * 0.25},${h * 0.25} l-${w * 0.25},${h * 0.25} v-${h * 0.15} l-${w * 0.35},0 
        l-${w * 0.15},${h * 0.15} l-${w * 0.25},0 l${w * 0.15},-${h * 0.25} Z" />
        <line x1="${(w * 3) / 4}" y1="5" x2="${(w * 3) / 4}" y2="${(h * 5) / 4}" />
        `,
  }),
};
